import { defineComponent as _defineComponent } from 'vue'
import NavItem from '@/components/nav/NavItem.vue'
import { useGetDashboardsQuery } from '@/api/dashboards'
import { computed, onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AnalyticsPopOver',
  setup(__props) {

const { data: dashboards, refetch } = useGetDashboardsQuery()

const availableRoutes = computed(
  () =>
    dashboards.value?.map((dashboard) => ({
      label: dashboard.name,
      to: `/analytics/dashboards/${dashboard.id}`,
      key: `${dashboard.id}-${dashboard.name}`,
    })) ?? []
)

onMounted(() => {
  refetch()
})

return { __sfc: true,dashboards, refetch, availableRoutes, NavItem }
}

})